import { api } from "../redux.js";

export interface CustomFieldName {
  id: string;
  display_name: string;
}

const customFieldNameApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Names for the date fields a playbook can report interactions under. A
     * dedicated endpoint because the user-custom-field list is scoped to
     * `provider = "user"`, which excludes account-level fields — the common
     * basis — and so would silently mislabel the creation-date filter.
     */
    createdAtBasisFieldNames: builder.query<CustomFieldName[], void>({
      query: () => `/custom_fields/created-at-basis-field-names`,
      transformResponse: (response: {
        data: { custom_field_names: CustomFieldName[] };
      }) => response.data.custom_field_names,
    }),
  }),
});

export const { useCreatedAtBasisFieldNamesQuery } = customFieldNameApi;
